var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFepiF(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.078%",
    y1: "-42.331%",
    x2: "28.71%",
    y2: "116.534%",
    id: "1s7wxqpq3a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8B4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4603",
    offset: "35.67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CE",
    offset: "82.077%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8225FF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8225FF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57 11.587c0-1.403.363-2.478 1.09-3.225.7-.72 1.74-1.087 3.115-1.1H15V.968h-4.282C7.608.993 5.104 1.985 3.206 3.94 1.28 5.897.319 8.446.319 11.587v18.09H6.57V17.746h7.532V12.01H6.57v-.424z",
    fill: "url(#1s7wxqpq3a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFepiF);
export default __webpack_public_path__ + "static/media/ic_fepi_f.1adca5947eef2c2fd61ebe4f48600e37.svg";
export { ForwardRef as ReactComponent };